import React from "react";
import { Link } from "react-router-dom";

const Home = () => (
  <div className="page__home">
    <h1>Home</h1>
    <ul>
      <li>
        <Link to="/form">EVP Fund III</Link>
      </li>
    </ul>
  </div>
);

export default Home;
